import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const NlFlag = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 18"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g clipPath="url(#nl-flag_svg__a)">
                <path fill="#AE1C28" d="M0 0h24v6H0z" />
                <path fill="#fff" d="M0 6h24v6H0z" />
                <path fill="#21468A" d="M0 12h24v6H0z" />
            </g>
            <rect width={23} height={17} x={0.5} y={0.5} stroke="#1F1D47" strokeOpacity={0.12} rx={1.5} />
            <defs>
                <clipPath id="nl-flag_svg__a">
                    <rect width={24} height={18} fill="#fff" rx={2} />
                </clipPath>
            </defs>
        </svg>
    </IconWrapper>
)
